module.exports = __webpack_public_path__ + "img/vinyl.fcaf05eb.jpg";